module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Safenwil_AG-b5e16fdf744521f26af9a14eed2d597c.svg";